/* @ngInject */
function DownloadMaterialsTabController ($scope, $rootScope, $interval, $translate, $q, ArtsService, SocketService, ToastService, UdsModalService) {
  const getMultipleDownloadDialogController = () => $q.when(import('../../dialogs/multiple-download-dialog/multiple-download-dialog.controller'))
  $scope.minimizeIcon = 'chevron-down'
  $scope.minimized = false
  $scope.flags = {
    isDownloading: false,
    error: false,
    success: false
  }

  $scope.showDownloadTab = false
  $scope.percentage = 0

  let selectedMaterials = []
  let artCollectionIds = []
  let fileFormat = 'png'

  const api = {
    getMultipleDownloadDialogController,
    _downloadMaterials,
    _handlePercentage,
    _resetFlags,
    _renderMaterials,
    _successDownload,
    _errorDownload,
    _connectSocket,
    _onRenderComplete,
    _onRenderProgress,
    _openDownloadDialog
  }

  this.getApi = () => api

  const deregisterDownloadMaterialsTab = $scope.$on('downloadMaterialsTab.start-download', (event, render, materials = [], collections = []) => {
    api._resetFlags()
    $scope.showDownloadTab = false
    $scope.count = materials.length + collections.length

    selectedMaterials = []
    artCollectionIds = []
    fileFormat = 'png'

    if (render) {
      selectedMaterials = materials
      api._connectSocket()
      api._openDownloadDialog()
    } else {
      artCollectionIds = collections.map(collection => collection.id)
      api._downloadMaterials(materials, artCollectionIds)
    }
  })

  const deregisterSocketConnected = $rootScope.$on('socket-connected-successfully-MultipleRender', () => {
    SocketService.registerEvent('multiple-render:progress', api._onRenderProgress, 'MultipleRender')
    SocketService.registerEvent('multiple-render:error', api._errorDownload, 'MultipleRender')
    SocketService.registerEvent('multiple-render:failed', api._errorDownload, 'MultipleRender')
    SocketService.registerEvent('multiple-render:completed', api._onRenderComplete, 'MultipleRender')
  })

  $scope.$on('$destroy', () => {
    deregisterDownloadMaterialsTab()
    deregisterSocketConnected()
  })

  $scope.minimizeOrMaximize = () => {
    $scope.minimized = !$scope.minimized
    $scope.minimizeIcon = $scope.minimized ? 'chevron-up' : 'chevron-down'
  }

  $scope.closeTab = () => {
    $scope.showDownloadTab = false
    $scope.flags = {
      isDownloading: false,
      error: false,
      success: false
    }
  }

  function _downloadMaterials (materials, artCollectionIds) {
    $scope.showDownloadTab = true
    $scope.flags.isDownloading = true
    const artIds = materials.map(material => material.id)
    api._handlePercentage()
    ArtsService.batchDownloadMaterials(artIds, artCollectionIds, fileFormat).then(api._successDownload).catch(api._errorDownload)
  }

  function _renderMaterials (materials) {
    $scope.flags.isDownloading = true
    const artIds = materials.map(material => material.id)
    selectedMaterials = materials

    ArtsService.batchRenderMaterials(artIds, fileFormat).catch(api._errorDownload)
  }

  function _handlePercentage () {
    $scope.percentage = 0

    const interval = $interval(() => {
      if ($scope.percentage < 100) {
        $scope.percentage += 10
      } else {
        $interval.cancel(interval)
      }
    }, 100)
  }

  function _resetFlags () {
    $scope.minimizeIcon = 'chevron-down'
    $scope.minimized = false
    $scope.flags = {
      isDownloading: false,
      error: false,
      success: false
    }

    $scope.showDownloadTab = false
    $scope.percentage = 0
  }

  function _successDownload () {
    $scope.flags.success = true
    $scope.flags.isDownloading = false
    $scope.percentage = 100
  }

  function _errorDownload (error) {
    $scope.flags.error = true
    $scope.flags.isDownloading = false
    $scope.percentage = 0

    if (error.code === 'NOT_FOUND') {
      ToastService.showErrorToast($translate.instant('artsNotFound'))
    }
  }

  function _connectSocket () {
    if (!SocketService.isConnected('MultipleRender')) {
      SocketService.connectSocket('MultipleRender')
    }
  }

  function _onRenderComplete (info) {
    const artIds = info.files.map(file => file.artId)
    const originalExtension = info.files[0]?.originalExtension || 'png'
    ArtsService.batchDownloadMaterials(artIds, null, fileFormat, originalExtension).then(api._successDownload).catch(api._errorDownload)
  }

  function _onRenderProgress (info) {
    $scope.percentage = info.completed / info.total * 100
  }

  function _openDownloadDialog () {
    api.getMultipleDownloadDialogController().then(({ MultipleDownloadDialogController }) => {
      const downloadDialog = UdsModalService.createModal({
        controller: MultipleDownloadDialogController,
        modalName: 'multipleDownloadDialog',
        data: {
          materials: selectedMaterials
        },
        onClose: (info) => {
          if (info.fileFormat) {
            fileFormat = info.fileFormat
            $scope.showDownloadTab = true
            api._renderMaterials(info.compatibleMaterials)
          }
        }
      })

      downloadDialog.open()
    })
  }
}

export { DownloadMaterialsTabController }
